const tooltipContainer = {
    border: '0.125rem solid',
    padding: '0.5625rem 1rem',
    fontWeight: '700',
    fontSize: '1.125rem',
};

export const container = ({ theme: { colors } }) => ({
    ...tooltipContainer,
    background: colors.white,
    color: colors.blue,
});

export const testimonialContainer = ({ theme: { colors } }) => ({
    ...tooltipContainer,
    background: colors.white,
    color: colors.fuchsia,
});
